import React, { useState, useEffect } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/Pages.css";
import "../styles/HariParamrut.css";

function HariParamrut() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          //"http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=4",
          "https://hariprabodham.org.in/api/?category=4",
        );
        if (!response.ok) {
          throw new Error("Failed to fetch videos");
        }
        const data = await response.json();

        const parseInfoDate = (value) => {
          if (!value) return 0;

          const timestamp = Date.parse(value);
          if (!Number.isNaN(timestamp)) return timestamp;

          // Fallback for common dd-mm-yyyy or dd/mm/yyyy formats.
          const match = String(value).match(
            /^(\d{1,2})[-/](\d{1,2})[-/](\d{2,4})$/,
          );
          if (!match) return 0;

          const day = Number(match[1]);
          const month = Number(match[2]) - 1;
          const year = Number(
            match[3].length === 2 ? `20${match[3]}` : match[3],
          );
          return new Date(year, month, day).getTime();
        };

        const parseSrno = (value) => {
          if (value === null || value === undefined) return 0;
          if (typeof value === "string" && value.trim() === "") return 0;

          const parsed = Number(value);
          return Number.isFinite(parsed) ? parsed : 0;
        };

        const sortedData = [...data].sort((a, b) => {
          const srnoA = parseSrno(a.SrNo ?? a.srno);
          const srnoB = parseSrno(b.SrNo ?? b.srno);

          if (srnoA !== srnoB) {
            return srnoA - srnoB;
          }

          return (
            parseInfoDate(a.infodate ?? a.InfoDate) -
            parseInfoDate(b.infodate ?? b.InfoDate)
          );
        });

        // Transform the data to match our format
        const transformedVideos = sortedData.map((video) => ({
          id: video.VideoUrl.replace("https://www.youtube.com/watch?v=", ""),
          title: video.Title,
          location: video.City || "",
          srno: parseSrno(video.SrNo ?? video.srno),
          infoDateTs: parseInfoDate(video.infodate ?? video.InfoDate),
          sabhaDetail: (video.SabhaDetail ?? "").toString(),
        }));

        setVideos(transformedVideos);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching videos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const openVideoModal = (videoId, title) => {
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };

  const isSpecialSabhaDetail = (value) => {
    const text = (value ?? "").toString().trim().toLowerCase();
    if (text === "multiple date") return true;
    return /^date\s*=\s*\?\?$/.test(text);
  };

  const videosWithSpecialSabhaDetail = videos
    .filter((video) => isSpecialSabhaDetail(video.sabhaDetail))
    .sort((a, b) => a.infoDateTs - b.infoDateTs);

  const videosWithSrno = videos.filter(
    (video) => video.srno > 0 && !isSpecialSabhaDetail(video.sabhaDetail),
  );
  const videosWithoutSrno = videos
    .filter(
      (video) => video.srno === 0 && !isSpecialSabhaDetail(video.sabhaDetail),
    )
    .sort((a, b) => a.infoDateTs - b.infoDateTs);

  const renderVideoGrid = (videoList) => (
    <div className="video-grid">
      {videoList.map((video, index) => (
        <div
          key={`${video.id}-${index}`}
          className="video-card"
          onClick={() => openVideoModal(video.id, video.title)}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === "Enter") openVideoModal(video.id, video.title);
          }}
        >
          <div className="video-thumbnail">
            <img
              src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
              alt={video.title}
            />
            <div className="play-overlay">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
          <div className="video-info">
            <h3>{video.title}</h3>
            {video.location && (
              <p className="video-location">{video.location}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <main className="page-content pravachan-page">
      <section className="page-header">
        <h1 className="section-title">
          Hari Paramrut
          {!loading && !error && (
            <span
              style={{ fontSize: "1rem", marginLeft: "12px", color: "#888" }}
            >
              ({videos.length})
            </span>
          )}
        </h1>
        <p className="header-subtitle">
          Guruhari P.P. Hariprasad Swamishri Paravani
        </p>
      </section>

      <section className="page-body">
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading videos...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p>Error loading videos: {error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}

        {!loading && !error && (
          <>
            {videosWithSrno.length > 0 && (
              <section>
                <h2 style={{ marginBottom: "12px" }}>Hari Paramut 1</h2>
                {renderVideoGrid(videosWithSrno)}
              </section>
            )}

            {videosWithoutSrno.length > 0 && (
              <section style={{ marginTop: "28px" }}>
                <h2 style={{ marginBottom: "12px" }}>Hari Paramut 2</h2>
                {renderVideoGrid(videosWithoutSrno)}
              </section>
            )}

            {videosWithSpecialSabhaDetail.length > 0 && (
              <section style={{ marginTop: "28px" }}>
                <h2 style={{ marginBottom: "12px" }}>Hari Paramut 3</h2>
                {renderVideoGrid(videosWithSpecialSabhaDetail)}
              </section>
            )}
          </>
        )}
      </section>

      {isModalOpen && (
        <VideoModal
          videoId={selectedVideoId}
          title={selectedVideoTitle}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </main>
  );
}

export default HariParamrut;
